import { Module, forwardRef } from '@nestjs/common';
import { MongooseModule } from '@nestjs/mongoose';
import { OrderController } from './controllers/order.controller';
import { OrderService } from './services/order.service';
import { Order, OrderSchema } from './schemas/order.schema';
import { Product, ProductSchema } from '../product/schemas/product.schema';
import { Package, PackageSchema } from '../package/schemas/package.schema';
import { ProductModule } from '../product/product.module';
import { UserModule } from '../user/user.module';
import { CouponModule } from '../coupon/coupon.module';
import { AuthModule } from '../auth/auth.module';
import { InventoryModule } from '../inventory/inventory.module';
import { PackageModule } from '../package/package.module';
import { StatisticsModule } from '../statistics/statistics.module';
import { EmailModule } from '../email/email.module';
import { BusinessProfileModule } from '../business-profile/business-profile.module';

@Module({
  imports: [
    MongooseModule.forFeature([
      { name: Order.name, schema: OrderSchema },
      { name: Product.name, schema: ProductSchema },
      { name: Package.name, schema: PackageSchema },
    ]),
    forwardRef(() => ProductModule),
    forwardRef(() => UserModule),
    forwardRef(() => CouponModule),
    forwardRef(() => AuthModule),
    forwardRef(() => InventoryModule),
    forwardRef(() => PackageModule),
    forwardRef(() => StatisticsModule),
    EmailModule,
    BusinessProfileModule,
  ],
  controllers: [OrderController],
  providers: [OrderService],
  exports: [OrderService],
})
export class OrderModule {}
